/**
 * Email normalization utilities
 * Ensures consistent email handling across the application
 */

/**
 * Normalizes an email address by converting to lowercase and trimming whitespace
 * @param email The email address to normalize
 * @returns The normalized email address
 */
export function normalizeEmail(email: string): string {
  if (!email) return '';
  return email.toLowerCase().trim();
}

/**
 * Handles email input changes by normalizing the email address
 * @param event The input event from an email field
 * @returns The normalized email value
 */
export function handleEmailInput(event: any): string {
  const value = event.detail?.value || event.target?.value || '';
  return normalizeEmail(value);
}

/**
 * Validates if an email address is properly formatted after normalization
 * @param email The email address to validate
 * @returns True if the email is valid, false otherwise
 */
export function isValidEmail(email: string): boolean {
  const normalized = normalizeEmail(email);
  if (!normalized) return false;
  
  // Basic email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(normalized);
}
